module.exports = __webpack_public_path__ + "static/media/CR.41a8307b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/country-flags/CR.svg
// module id = 2133
// module chunks = 7